<div class="modal-header">
  <h4 class="modal-title">{{ 'workflow_data_store.singular' | translate }}</h4>
  <button
    type="button"
    class="btn-close"
    (click)="modalRef.close()"
    aria-label="Close"
  ></button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="row g-3">
      <div class="col-md-12 form-group">
        <label>{{ 'workflow_data_store.name' | translate }}</label>
        <input class="form-control" formControlName="name" />
      </div>
      <div class="col-md-12 form-group">
        <label>{{ 'workflow_data_store.identifier' | translate }}</label>
        <input class="form-control" formControlName="identifier" />
      </div>
      <div class="col-md-12 form-group">
        <label>{{ 'workflow_data_store.description' | translate }}</label>
        <textarea
          class="form-control"
          formControlName="description"
          rows="3"
        ></textarea>
      </div>
    </div>
  </form>
  <app-error [error]="error"></app-error>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-primary"
    (click)="modalRef.close()"
  >
    {{ 'close' | translate }}
  </button>
  <button
    type="button"
    class="btn btn-primary"
    (click)="save()"
    [ladda]="loading"
  >
    {{ 'save' | translate }}
  </button>
</div>
